import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BoostrapProgressBar from 'react-bootstrap/lib/ProgressBar';

import './_ProgressBar.scss';

/**
 * A component for displaying progress. This component wraps react-bootstrap's ProgressBar
 */
const ProgressBar = props => {
  const { className, ...otherProps } = props;
  const classes = classNames('ProgressBar', className);
  return (
    <div className={classes}>
      <BoostrapProgressBar {...otherProps} />
    </div>
  );
};

ProgressBar.propTypes = {
  ...BoostrapProgressBar.propTypes,
  /**
   * A custom className for the container element of the component
   */
  className: PropTypes.string
};

export default ProgressBar;
